<section class="cleanup">
  <header>
    <h1>Nettoyage des traces</h1>
    <p>Choisissez un protocole et un mois calendaire (Europe/Paris). Le premier calcul crée un index sur la date et peut prendre plusieurs minutes.</p>
  </header>

  <mat-button-toggle-group [value]="protocol" [disabled]="busy" (change)="setProtocol($event.value)">
    <mat-button-toggle value="OCPP">OCPP</mat-button-toggle>
    <mat-button-toggle value="OKECHARGE">Okecharge</mat-button-toggle>
  </mat-button-toggle-group>

  <div class="year">
    <button mat-icon-button type="button" aria-label="Année précédente" [disabled]="busy" (click)="shiftYear(-1)">
      <mat-icon>chevron_left</mat-icon>
    </button>
    <strong>{{ year }}</strong>
    <button mat-icon-button type="button" aria-label="Année suivante" [disabled]="busy || year >= currentYear" (click)="shiftYear(1)">
      <mat-icon>chevron_right</mat-icon>
    </button>
    <span class="month-title">{{ monthTitle }}</span>
  </div>

  <div class="months">
    @for (monthNumber of monthIndexes; track monthNumber) {
      <button
        mat-stroked-button
        type="button"
        class="month"
        [class.selected]="monthNumber === month"
        [disabled]="busy || isFuture(year, monthNumber)"
        (click)="selectMonth(monthNumber)">
        {{ months[monthNumber - 1] }}
      </button>
    }
  </div>

  @if (loading) {
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    <p class="status">Calcul du volume…</p>
  }

  @if (error) {
    <p class="error">{{ error }}</p>
  }

  @if (summary) {
    <mat-card class="volume">
      <p class="period">{{ periodLabel }}</p>
      @if (isCurrentMonth) {
        <p class="notice">Ce mois est en cours. De nouvelles traces peuvent encore arriver.</p>
      }
      <div class="figures">
        <div>
          <span>Traces</span>
          <strong>{{ countLabel }}</strong>
        </div>
        <div>
          <span>Taille estimée</span>
          <strong>{{ sizeLabel }}</strong>
        </div>
      </div>
      <p class="hint">La taille est estimée à partir de la taille moyenne d’un document de la collection.</p>

      @if (deleting) {
        <mat-progress-bar mode="determinate" [value]="deleteProgress"></mat-progress-bar>
        <p class="status">{{ deletedLabel }} traces supprimées</p>
      }
      @if (downloading) {
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
        <p class="status">Préparation du fichier…</p>
      }

      @if (summary.count > 0 && !downloaded && !downloading) {
        <p class="hint">Téléchargez le fichier pour pouvoir supprimer ces traces.</p>
      }

      <div class="actions">
        <button mat-flat-button color="primary" type="button" [disabled]="!canDownload" (click)="download()">
          <mat-icon>download</mat-icon>
          Télécharger
        </button>
        <button mat-flat-button color="warn" type="button" [disabled]="!canDelete" (click)="confirmDelete()">
          <mat-icon>delete</mat-icon>
          Supprimer
        </button>
      </div>
    </mat-card>
  }
</section>
